<!-- NEED OPTIMIZATION COMPONENT -->
<template>
  <section class="log-time-report container-fluid">
    <div class="position-relative full-height-page-wrapper">

      <PageHeader showBreadcrumbs page-title="Log time report">
        <template #buttons>
          <LogTimeAdd @createdLogTime="reloadReport" />
          <TimeOffAdd @createdTimeOff="reloadReport" />
          <b-button class="button" :variant="isShowFilter ? 'info' : 'secondary'" @click="toggleShowFilter">
            <span class="material-icons icon-image-preview"> tune </span>
            Filters
          </b-button>
        </template>
      </PageHeader>

      <Filters v-if="$can('read_all-log_time_reports')" v-show="isShowFilter" textButtonSubmit="Get Report"
        resetToInitial :data="filters" :isLoading="showPreloader && isInitialDataLoaded" @submit="filterReport" />

      <div v-if="showPreloader && !isInitialDataLoaded" class="content-loading-wrapper">
        <Preloader class="centered-preloader" />
      </div>
      <FullscreenTabs v-else-if="isInitialDataLoaded && Object.keys(totalByUsers).length > 0" :class="{ 'loading-data': showPreloader && isInitialDataLoaded }">
        <template v-slot:tabsControls>
          <div class="d-flex">
            <div class="table-tab-item" v-for="tab in tabs" :key="tab.name">
              <b-button class="button text-capitalize tab-radius" :variant="tab.name === currentTab.name ? 'info' : 'secondary-outline'
                " @click="setCurrentTab(tab)">
                {{ tab.alias }}
              </b-button>
            </div>
          </div>
        </template>
        <template v-if="currentTab.name === 'byPeople' && showZeroValues" v-slot:tabsControlsRight>
          <b-form-group class="btn-icon button-checkbox_sm w-100 switch-group">
            <b-form-checkbox size="sm" switch v-model="showVerifyComments" class="switch show-verify-checkbox">Verify
              comments</b-form-checkbox>
          </b-form-group>
          <b-form-group class="btn-icon button-checkbox_sm w-100 switch-group">
            <b-form-checkbox size="sm" switch v-model="showVerifyHours" class="switch show-verify-checkbox">Verify
              hours</b-form-checkbox>
          </b-form-group>
        </template>
        <template v-slot:tabsContent>
          <div>
            <div v-show="currentTab.name === 'byPeople'" class="table__theme-default">
              <div class="table-container" v-if="reportsByUsers.length">
                <div style="overflow: auto">
                  <table class="table user-table b-table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th v-for="field in fieldsPeople" :key="field.key" scope="col"
                          class="column-long-name align-middle position-relative"
                          :class="field.key === 'name' && 'th-name'" @click="sortTable(field.key)"
                          :aria-sort="currentSortDirection">
                          <div>{{ field.label }}</div>
                        </th>
                        <th class="align-middle" scope="col">report</th>
                        <th scope="col" class="th-else align-middle">
                          {{totalByUsers.find((item) => item.date === "total").date}}
                        </th>
                        <th v-for="spentTime in totalByUsers" :key="spentTime.date" scope="col" class="th-else">
                          <template v-if="spentTime.date === 'total'">total</template>
                          <template v-else>
                            {{ getHeaderDateFormatted(spentTime.date) }}<br>
                            {{ getHeaderWeekdayFormatted(spentTime.date) }}
                          </template>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reportsByUsers" :key="report.user.id">
                        <td>{{ index + 1 }}</td>
                        <td scope="col" class="cursor-pointer align-items-center d-flex"
                          v-b-tooltip.html="{ variant: 'base', placement: 'top', placement: 'top', boundary: 'viewport' }"
                          :title="createUserTooltip(report)">
                          <TableUserItem :user="report.user" :number="index" :user-tooltip="false" />
                        </td>
                        <td scope="col" class="text-center">
                          <button class="btn d-flex" @click="openTimeOffReportModal(report.user)">
                            <span v-html="draftIconSvg"></span>
                          </button>
                        </td>
                        <td scope="col">
                          <div class="spent-time">
                            {{ formatLogTime(getReportDateAttribute(report, "total", "spent_time")) }}
                          </div>
                        </td>
                        <template v-for="totalItem in totalByUsers">
                          <template
                            v-if="!isWeekendOrHoliday(report.user.name, totalItem.date) || getReportDateAttribute(report, totalItem.date, 'spent_time')">
                            <td scope="col" :key="totalItem.date" :class="totalItem.date != 'total'
                              ? 'working-day-' +
                              getUserDayType(report.user.name, totalItem.date) +
                              (isNotWorkingDay(report, totalItem.date) &&
                                showVerifyHours ? ' working-day-part-time' : '')
                              : ''
                              " :title="getDayTitle(report, totalItem.date)"
                              @click="totalItem.date != 'total' && showLogTimesModal(report, totalItem.date)">
                              <div class="spent-time"
                                :class="[(isVacationDay(report.user.name, totalItem.date) || isSickDay(report.user.name, totalItem.date)) && 'flex-column', totalItem.date != 'total' && 'cursor-pointer']">
                                <span v-if="isVacationDay(report.user.name, totalItem.date)"
                                  class="vacation-day d-flex justify-content-center align-items-center"
                                  v-b-tooltip.html="{ variant: 'base', placement: 'top', placement: 'top', boundary: 'viewport' }"
                                  :style="{
                                    backgroundColor: report.dates[totalItem.date].time_offs_settings.color,
                                  }" :class="{ 'half-day': isDisplayHalfDay(report, totalItem.date) }"
                                  :title="report.dates[totalItem.date].time_offs_settings.name">
                                  <TimeOffIcon :name="report.dates[totalItem.date].time_offs_settings.icon"
                                    variant="white" className="time-off-icon" />
                                </span>
                                <span v-if="isSickDay(report.user.name, totalItem.date)"
                                  class="sick-day d-flex justify-content-center" :style="{
                                    backgroundColor: report.dates[totalItem.date].time_offs_settings.color,
                                  }">
                                  <TimeOffIcon :name="report.dates[totalItem.date].time_offs_settings.icon"
                                    variant="white" className="time-off-icon" />
                                </span>
                                <div class="d-flex">
                                  <span class="text-nowrap"
                                    v-if="!(isVacationDay(report.user.name, totalItem.date) && getReportDateAttribute(report, totalItem.date, 'spent_time') === 0)">
                                    {{ formatLogTime(getReportDateAttribute(report, totalItem.date, 'spent_time')) }}
                                  </span>
                                  <span v-if="isReportedDay(report, totalItem.date)"
                                    class="material-icons icon-image-preview">
                                    done_all
                                  </span>
                                  <span
                                    v-else-if="showZeroValues && isCommentedDay(report, totalItem.date) && getReportDateAttribute(report, totalItem.date, 'spent_time') !== 0"
                                    class="material-icons icon-image-preview">
                                    done
                                  </span>
                                </div>
                              </div>
                            </td>
                          </template>
                          <template v-else>
                            <td scope="col" :class="isWorkingDay(report.user.name, totalItem.date)
                              ? 'working-day-part-time'
                              : 'working-day-' +
                              getUserDayType(report.user.name, totalItem.date)
                              " :key="`working-day-${totalItem.date}`"
                              @click="showLogTimesModal(report, totalItem.date)"
                              :title="getDayTitle(report, totalItem.date)">
                              <div class="spent-time cursor-pointer" :style="{
                                backgroundColor: getUserDayColor(report.user.name, totalItem.date),
                              }">
                                <template v-if="isWorkingDay(report.user.name, totalItem.date)">
                                  {{ showZeroValues ? "0" : "" }}
                                </template>
                              </div>
                            </td>
                          </template>
                        </template>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="align-middle total">Total</td>
                        <td class="text-center">
                          <button class="btn d-flex" @click="openCommonTimeOffReportModal()">
                            <span v-html="draftIconSvg"></span>
                          </button>
                        </td>
                        <td>
                          <div class="spent-time text-nowrap">{{ formatLogTime(totalByUsers[totalByUsers.length -
                            1].spent_time) }}</div>
                        </td>
                        <td v-for="(totalItem, index) in totalByUsers" scope="col"
                          :key="String(index) + totalItem.date">
                          <div class="spent-time text-nowrap">
                            {{ showZeroValues || totalItem.spent_time !== 0 ? formatLogTime(totalItem.spent_time) : ""
                            }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="p-3">No data</div>
            </div>
            <div v-show="currentTab.name === 'byProjects'" class="table__theme-default">
              <div class="table-container" v-if="reportsByProject.length">
                <div style="overflow: auto">
                  <table class="table b-table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th v-for="field in fieldsProjects" :key="field.key" :class="field.class" class="align-middle"
                          scope="col">
                          {{ field.label }}
                        </th>
                        <th v-for="spentTime in totalByProjects" :key="spentTime.date" class="text-center" scope="col">
                          <template v-if="spentTime.date === 'total'">total</template>
                          <template v-else>
                            {{ getHeaderDateFormatted(spentTime.date) }}<br>
                            {{ getHeaderWeekdayFormatted(spentTime.date) }}
                          </template>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reportsByProject" :key="report.key">
                        <td>{{ index + 1 }}</td>
                        <td scope="col">
                          <div class="d-flex align-items-center">
                            <div class="d-flex flex-column">
                              <span>{{ report.project.name }}</span>
                              <a target="_blank" v-if="report.project.external_link"
                                :href="report.project.external_link">
                                {{ report.project.key }}
                              </a>
                              <span class="user-position">{{ report.project.key }}</span>
                            </div>
                          </div>
                        </td>
                        <td class="text-center text-nowrap" scope="col">
                          {{ report.dates.total.spent_time }}
                        </td>
                        <template v-for="(totalItem) in totalByProjects">
                          <td class="text-center text-nowrap" scope="col" :key="`has-report-${totalItem.date}`"
                            v-if="report.dates[totalItem.date] && !isProjectWeekend(totalItem.date_formatted)">
                            {{ getReportDateAttribute(report, totalItem.date, 'spent_time') }}</td>
                          <td class="text-center" scope="col" :key="`is-weekend-${totalItem.date}`"
                            v-else-if="isProjectWeekend(totalItem.date_formatted)">
                            <div class="weekend">{{ getReportDateAttribute(report, totalItem.date, 'spent_time') === 0 ?
                              '' : getReportDateAttribute(report, totalItem.date, 'spent_time') }}</div>
                          </td>
                          <td class="text-center" v-else scope="col" :key="`no-report-${totalItem.date}`">-</td>
                        </template>
                      </tr>
                      <tr>
                        <td></td>
                        <td class="align-middle text-left total">Total</td>
                        <td class="text-nowrap text-center">{{ totalByProjects[totalByProjects.length - 1].spent_time }}
                        </td>
                        <td v-for="(totalItem) in totalByProjects" class="text-center text-nowrap" scope="col"
                          :key="totalItem.date">{{ (showZeroValues ||
                            totalItem.spent_time !== 0) ? totalItem.spent_time : '' }}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="p-3">No data</div>
            </div>
            <div v-show="currentTab.name === 'byTasks'" class="table__theme-default">
              <div class="table-container" v-if="reportsByTasks.length">
                <div style="overflow: auto">
                  <table class="table b-table table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th v-for="field in fieldsTasks" :key="field.key" :class="field.class" class="align-middle"
                          scope="col">
                          {{ field.label }}
                        </th>
                        <th v-for="spentTime in totalByTasks" :key="spentTime.date" class="text-center" scope="col">
                          <template v-if="spentTime.date === 'total'">total</template>
                          <template v-else>
                            {{ getHeaderDateFormatted(spentTime.date) }}<br>
                            {{ getHeaderWeekdayFormatted(spentTime.date) }}
                          </template>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reportsByTasks" :key="report.id + String(index)">
                        <td>{{ index + 1 }}</td>
                        <td scope="col">
                          <div class="d-flex align-items-center">
                            <div class="d-flex flex-column">
                              <span>{{ report.task.project ? report.task.project.name : 'No project' }}</span>
                              <template v-if="report.task.project">
                                <a target="_blank" v-if="report.task.project.external_link"
                                  :href="report.task.project.external_link">{{ report.task.project.key }}</a>
                                <span class="user-position" v-else>{{ report.task.project.key }}</span>
                              </template>
                              <span class="user-position" v-else>no project</span>
                            </div>
                          </div>
                        </td>
                        <td scope="col">
                          <span v-if="report.task.external_link">
                            <a class="task-name-link" target="_blank" :href="report.task.external_link">
                              {{ report.task.name }}
                              <span v-if="report.task.external_fields">({{ report.task.external_fields.key }})</span>
                            </a>
                          </span>
                          <span v-else>{{ report.task.name }}</span>
                        </td>
                        <td class="text-center text-nowrap" scope="col">
                          {{ report.dates.total.spent_time }}
                        </td>
                        <template v-for="(totalItem) in totalByTasks">
                          <td scope="col" class="text-center text-nowrap" :key="totalItem.date"
                            v-if="report.dates[totalItem.date] && !isProjectWeekend(totalItem.date_formatted)">
                            {{ getReportDateAttribute(report, totalItem.date, 'spent_time') }}</td>
                          <td class="text-center" scope="col" :key="`is-weekend-${totalItem.date}`"
                            v-else-if="isProjectWeekend(totalItem.date_formatted)">
                            <div class="weekend">{{ getReportDateAttribute(report, totalItem.date, 'spent_time') === 0 ?
                              '' : getReportDateAttribute(report, totalItem.date, 'spent_time') }}</div>
                          </td>
                          <td v-else scope="col" :key="`no-report-${totalItem.date}`">-</td>
                        </template>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td class="align-middle text-left total">Total</td>
                        <td class="text-nowrap text-center">{{ totalByTasks[totalByTasks.length - 1].spent_time }}</td>
                        <td v-for="(totalItem) in totalByTasks" scope="col" class="text-nowrap text-center"
                          :key="totalItem.date">
                          {{ (showZeroValues ||
                            totalItem.spent_time !== 0) ? totalItem.spent_time : '' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else class="p-3">No data</div>
            </div>
          </div>
        </template>
      </FullscreenTabs>
      <div
        v-if="isInitialDataLoaded && Object.keys(totalByUsers).length === 0"
        class="full-height-content"
      >
        <EmptyStateNoResults
          title="No time report data yet"
          description="No logged time data found for the selected filters. Adjust your criteria or log some time first."
          customIcon="schedule"
          customIconClasses="material-symbols-outlined empty-state__icon"
          :withoutButton="true"
        />
      </div>
      <SlideOutContainerViaPortal>
        <div v-if="showTimeOffReport">
          <template v-if="isCommonTimeOffReport">

            <TimeOffReportOverview :isPage="false" :timeOffReportUserId="timeOffReportUserId"
              :hideMonthsSection="isCommonTimeOffReport" @close="closeTimeOffReport" />
          </template>
          <template v-else>

            <TimeOffReportById :isPage="false" :timeOffReportUserId="timeOffReportUserId"
              :hideMonthsSection="isCommonTimeOffReport" @close="closeTimeOffReport" :breadcrumbs="timeOffReportBreadcrumbs" />
          </template>

        </div>
      </SlideOutContainerViaPortal>
      <LogTimesModal v-if="logTimeModal.show" v-model="logTimeModal.show" :isLoading="logTimeModal.isLoading"
        :error="logTimeModal.error" :title="logTimeModal.title" :user="logTimeModal.user"
        :loggedAt="logTimeModal.loggedAt" :logTimes="logTimeModal.logTimes" @logTimesChanged="reloadReport" />
      <TimeOffReportModal v-if="showTimeOffReportModal" v-model="showTimeOffReportModal" :user="timeOffReportModalUser"
        :timeOffReportData="timeOffReportModalReport" :workedDaysReportData="userWorkedDaysReportModalReport"
        @dataUpdated="openTimeOffReportModal(timeOffReportModalUser)" />
      <CommonWorkedDaysReportModal v-if="showCommonTimeOffReportModal" v-model="showCommonTimeOffReportModal"
        :workedDaysReportData="commonTimeOffReportModalReport" @dataUpdated="openCommonTimeOffReportModal" />
      <TimeOffApprove v-if="timeOffForApproveId" v-model="timeOffForApproveId" @timeOffApproved="timeOffApproved" />
    </div>
  </section>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { getDateFrom } from '../functions/format_date'
import moment from 'moment'
import Preloader from '@components/Preloader'
import Filters from '@components/Filter/Filter'
import FullscreenTabs from '@components/Fullscreen/FullscreenTabs'
import TableUserItem from '@components/tables/TableUserItem'
import LogTimesModal from '../components/modals/LogTimesModal.vue'
import LogTimeAdd from '../components/LogTimeAdd.vue'
import TimeOffAdd from '../components/TimeOffAdd.vue'
import TimeOffReportModal from '../components/modals/TimeOffReportModal.vue'
import CommonWorkedDaysReportModal from '../components/modals/CommonWorkedDaysReportModal.vue'
import TimeOffApprove from '../components/TimeOffApprove.vue'
import TimeOffIcon from '@components/TimeOffIcon.vue'
import SlideOutContainerViaPortal from '@components/transition/SlideOutContainerViaPortal.vue'
import TimeOffReportById from '@pages/TimeOffReportById.vue'
import PageHeader from '@components/PageHeader.vue'
import ScrollPositionMixin from '@mixins/ScrollPositionMixin'
import { draftIconSvg } from '@/assets/icons/draftIcon'
import TimeOffReportOverview from '@pages/TimeOffReportOverview.vue'
import EmptyStateNoResults from '@components/EmptyStateNoResults'

export default {
  name: 'log-time-report',
  mixins: [ScrollPositionMixin],
  components: {
    Preloader,
    FullscreenTabs,
    Filters,
    TableUserItem,
    LogTimesModal,
    LogTimeAdd,
    TimeOffAdd,
    TimeOffReportModal,
    CommonWorkedDaysReportModal,
    TimeOffApprove,
    TimeOffIcon,
    SlideOutContainerViaPortal,
    TimeOffReportById,
    PageHeader,
    TimeOffReportOverview,
    EmptyStateNoResults
  },
  data () {
    return {
      showPreloader: true,
      isAllOptionsFilterSet: false,
      isLogTimeDataLoaded: false,
      showTimeOffReportModal: false,
      showCommonTimeOffReportModal: false,
      showVerifyComments: false,
      showVerifyHours: false,
      timeOffReportModalUser: null,
      timeOffReportModalReport: [],
      commonTimeOffReportModalReport: [],
      userWorkedDaysReportModalReport: [],
      isShowFilter: true,
      currentSortKey: 'name',
      draftIconSvg,
      currentSortDirection: 'ascending',
      currentTab: { name: 'byPeople', alias: 'By people' },
      tabs: [
        { name: 'byPeople', alias: 'By people' },
        { name: 'byProjects', alias: 'By projects' },
        { name: 'byTasks', alias: 'By Issues' }
      ],
      usersSummaryTime: [],
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: new Date(moment().startOf('month')),
          defaultValue: new Date(moment().startOf('month')),
          class: 'filters-width'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          validation: [{ name: 'required' }],
          value: new Date(moment()),
          defaultValue: new Date(moment()),
          class: 'filters-width'
        },
        'projects': {
          type: 'multiselect',
          name: 'projects',
          label: 'Select projects',
          valueField: 'key',
          selectLabel: 'label',
          options: [],
          value: [],
          class: 'filters-width'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          label: 'Select users',
          valueField: 'name',
          selectLabel: 'label',
          options: [],
          value: [],
          disabled: false,
          class: 'filters-width'
        },
        'unitManagers': {
          type: 'multiselect',
          name: 'unitManagers',
          label: 'Select unit manager',
          valueField: 'name',
          selectLabel: 'name',
          options: [],
          value: [],
          disabled: false,
          class: 'filters-width'
        },
        'show_with_empty_data': {
          type: 'switch',
          name: 'show_with_empty_data',
          label: 'Show users with empty data',
          value: false,
          class: 'filters-width log-time-report-filter-switch'
        },
        'show_time_offs_only': {
          type: 'switch',
          name: 'show_time_offs_only',
          label: 'Show time offs only',
          value: false,
          class: 'filters-width log-time-report-filter-switch'
        }
      },
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      form: {
        date_from: '',
        date_to: '',
        projects: [],
        users: [],
        unitManagers: []
      },
      projects: [],
      users: [],
      unitManagers: [],
      fieldsProjects: [
        {
          key: 'name',
          label: 'Project name',
          class: 'name-col',
          sortable: true
        },
        {
          key: 'totalProject',
          label: 'Total',
          class: 'text-center align-middle'
        }
      ],
      fieldsPeople: [
        {
          key: 'name',
          label: 'User',
          sortable: true,
          class: 'column-long-name',
          sortDirection: null
        }
      ],
      fieldsTasks: [
        {
          key: 'projectName',
          label: 'Project name',
          class: 'tasks-name-col',
          sortable: true
        },
        {
          key: 'key',
          label: 'Task name',
          class: 'task-col',
          sortable: true
        },
        {
          key: 'totalTask',
          label: 'Total',
          class: 'text-center align-middle'
        }
      ],
      reportsByUsers: [],
      reportsByProject: [],
      reportsByTasks: [],
      userWorkingDays: {},
      totalByUsers: [],
      totalByTasks: [],
      totalByProjects: [],
      firstday: '',
      lastday: '',
      currentDate: new Date(),
      logTimeModal: {
        show: false,
        isLoading: false,
        error: null,
        title: '',
        user: {},
        loggedAt: '',
        logTimes: []
      },
      timeOffForApproveId: null,
      showTimeOffReport: false,
      timeOffReportUserId: null,
      isCommonTimeOffReport: false
    }
  },
  watch: {
    'form.date_from': function (val) {
      if (moment(val, 'YYYY-MM-DD').isAfter(this.form.date_to, 'YYYY-MM-DD')) {
        this.form.date_to = this.form.date_from
      }
    }
  },
  computed: {
    isInitialDataLoaded () {
      return this.isAllOptionsFilterSet && this.isLogTimeDataLoaded
    },
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName',
      getProjects: 'projects/getProjects',
      getUser: 'getUser'
    }),
    showZeroValues () {
      return !this.filters.show_time_offs_only.value
    },
    timeOffReportBreadcrumbs () {
      return [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Log time report',
          click: () => this.closeTimeOffReport()
        },
        {
          text: 'Time off report - detailed',
          to: { name: 'time-off-report' }
        }
      ]
    }
  },
  created () {
    if (this.$can('read_own-log_time_reports') && !this.$can('read_all-log_time_reports')) {
      this.filters.users.value.push(this._UserInfo)
    }
  },
  async mounted () {
    this.filters.projects.options = await this.$api.projects.getProjects()
    await this.axios
      .post(
        '/api/users',
        {},
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          this.filters.users.options = response.data
        }
      })
      .catch(console.error)
    const isAdministrator = !!this.$store.getters.getUser.user_roles?.find(item => item.name === 'administrator')
    const isUnitManager = !!this.$store.getters.getUser.user_roles?.find(item => item.name === 'unit_manager')

    if (isAdministrator) {
      this.$api.users.getUnitManagers()

      if (Object.keys(this.$route.query).length !== 0) {
        for (let item in this.$route.query) {
          if (item.indexOf('users') !== -1) {
            this.filters.users.options.forEach((element, index) => {
              if (element.id === +this.$route.query[item]) {
                this.filters.users.value.push(element)
              }
            })
          } else if (item.indexOf('unitManagers') !== -1) {
            this.filters.unitManagers.options.forEach((element, index) => {
              if (element.id === +this.$route.query[item]) {
                this.filters.unitManagers.value.push(element)
              }
            })
          } else if (item.indexOf('projects') !== -1) {
            this.filters.projects.options.forEach((element, index) => {
              if (element.id === +this.$route.query[item]) {
                this.filters.projects.value.push(element)
              }
            })
          } else if (item === 'date_from') {
            this.filters.date_from.value = this._toLocalTime(this.$route.query[item])
          } else if (item === 'date_to') {
            this.filters.date_to.value = this._toLocalTime(this.$route.query[item])
          } else if (item === 'show_with_empty_data' && this.$route.query[item] === 'true') {
            this.filters.show_with_empty_data.value = true
          } else if (item === 'show_time_offs_only' && this.$route.query[item] === 'true') {
            this.filters.show_time_offs_only.value = true
          }
        }
      }
    } else if (isUnitManager) {
      const currentUserId = this.$store.getters.getUser.id
      const isCurrentUserInFilter = this.filters.unitManagers.options.filter(item => item.id === currentUserId).length
      if (!isCurrentUserInFilter) {
        this.filters.unitManagers.options.push(this.$store.getters.getUser)
      }
    } else {
      this.filters.users.options.forEach((element, index) => {
        if (element.id === this.getUser.id) {
          this.filters.users.value.push(element)
          this.filters.users.disabled = true
        }
      })
      this.filters.unitManagers.disabled = true
    }

    this.isAllOptionsFilterSet = true
    // if (this.$can('read_own-log_time_reports') && !this.$can('read_all-log_time_reports')) {
    await this.getReportAdpt(this.filters)
    // }

    if (this.$route.query['approved_time_off_id'] && this.$can('update_all-time_offs')) {
      this.timeOffForApproveId = this.$route.query['approved_time_off_id']
    }
  },
  methods: {
    async showLogTimesModal (reportUserItem, date) {
      this.logTimeModal = {
        show: true,
        isLoading: true,
        title: this.getDayTitle(reportUserItem, date)
      }

      await this.axios
        .get(
          '/api/log-times/fetch-user-day-items/' + reportUserItem.user.id + '/' + date,
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.logTimeModal = {
              ...this.logTimeModal,
              show: true,
              isLoading: false,
              user: reportUserItem.user,
              loggedAt: date,
              logTimes: response.data ? response.data : []
            }
          }
        })
        .catch(error => {
          console.error(error)

          this.logTimeModal.isLoading = false
          this.logTimeModal.error = error?.response?.data?.message || 'Something went wrong'
        })
    },
    createUserTooltip (report) {
      let message = `${report.user.name || ''} <br/> ${report.user.position || ''} <br/> ${report.user.employment_type.label || ''}/${report.user.payment_type || ''} <br/> Total: ${report.dates.total.spent_time || ''}`
      return `<div class="text-center" style="font-size: 12px;">${message}</div>`
    },
    setCurrentTab (tab) {
      this.currentTab = tab
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    getDate (date, target) {
      let result = getDateFrom(date, target)
      if (target === 'from') {
        this.form.date_from = result
      } else {
        this.form.date_to = result
      }
    },
    sortTable (key) {
      if (this.currentSortKey === key) {
        this.currentSortDirection = this.currentSortDirection === 'ascending' ? 'descending' : 'ascending'
      } else {
        this.currentSortKey = key
        this.currentSortDirection = 'ascending'
      }

      this.fieldsPeople.forEach(field => {
        field.sortDirection = field.key === key ? this.currentSortDirection : null
      })

      this.reportsByUsers.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDirection === 'descending') {
          modifier = -1
        }

        if (key === 'name') {
          const nameA = a.user.name.toUpperCase()
          const nameB = b.user.name.toUpperCase()
          if (nameA < nameB) return -1 * modifier
          if (nameA > nameB) return 1 * modifier
          return 0
        }
        return 0
      })
    },
    getUserDayType (userName, date) {
      const userDays = this.userWorkingDays[userName]
      if (userDays && userDays[date]) {
        return userDays[date]['type']
      }
      return '-'
    },
    getUserDayTimeOffSetting (userName, date) {
      const userDays = this.userWorkingDays[userName]
      if (userDays && userDays[date] && userDays[date]['time_offs_settings']) {
        return userDays[date]['time_offs_settings']
      }
      return { name: '', color: '' }
    },
    getUserDayColor (userName, date, isPending = false) {
      const timeOffSetting = this.getUserDayTimeOffSetting(userName, date)
      if (this.getUserDayType(userName, date) === 'time_off' && timeOffSetting) {
        return this._hexToRGB(timeOffSetting.color, isPending ? '0.3' : '1')
      } else {
        return null
      }
    },
    setCustomDate (data) {
      this.form.date_from = data.firstday
      this.form.date_to = data.lastday
      this.form.unitManagers = this.unitManagers.filter(element => {
        return element.name === this.getCurrentUserName
      })
    },
    filterReport (fieldsFromFilter) {
      const fields = cloneDeep(fieldsFromFilter)
      for (const name in this.filters) {
        if (name === 'date_from') {
          fields.date_from.value = this._toLocalTime(fields.date_from.value)
        } else if (name === 'date_to') {
          fields.date_to.value = this._toLocalTime(fields.date_to.value)
        }
        if (fields[name] !== undefined) {
          this.filters[name].value = this.form[name] = fields[name].value
        } else {
          this.filters[name].value = this.form[name] = null
        }
      }
      this._setRouteByFields(fields)
      this.getReportAdpt(fields)
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Object.prototype.toString.call(value) === '[object Date]') {
          value = this._toLocalTime(value)
        }

        if (Array.isArray(value)) {
          value = value.map(item => item[fields[key]['valueField']])
        }

        data[name] = value
      }

      return data
    },
    getReportAdpt (fields) {
      const data = this.prepareDataForGetReports(fields)
      this.getReport(data)
    },
    /* TODO optimization and replace getReportAdpt */
    getReport (fields) {
      this.showPreloader = true
      this.axios
        .post(
          '/api/report/logTime',
          fields,
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          this.showPreloader = false
          if (response.status === 200) {
            this.totalByUsers = Object.values(response.data.total_by_users)
            this.totalByTasks = Object.values(response.data.total_by_tasks)
            this.totalByProjects = Object.values(response.data.total_by_projects)
            this.reportsByUsers = Object.values(response.data.users)
            const that = this
            Object.keys(response.data.users).forEach(function (index) {
              const userName = response.data.users[index].user.name
              const userDates = response.data.users[index].dates
              that.userWorkingDays[userName] = userDates
            })
            this.reportsByProject = Object.values(response.data.projects)
            this.reportsByTasks = Object.values(response.data.tasks)
            this.isLogTimeDataLoaded = true
          }
        })
        .catch(err => {
          this.showPreloader = false
          this.errorNotifications(err)
        })
    },
    reloadReport () {
      this.getReportAdpt(this.filters)
    },
    getReportDateAttribute (report, date, attr) {
      const dateData = report.dates[date] || {}

      let value = dateData[attr]

      if (attr === 'spent_time' && dateData['spent_time'] !== undefined) {
        value = dateData['spent_time']

        // If time_off_spent_time exists, concatenate it
        if (dateData['time_off_spent_time'] !== undefined) {
          value -= dateData['time_off_spent_time']
        }
      }
      if (value === 0 && !this.showZeroValues) {
        value = ''
      }

      return value
    },
    isReportedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_reported') && this.showVerifyComments
    },
    isCommentedDay (report, date) {
      return this.getReportDateAttribute(report, date, 'is_commented') && this.showVerifyComments
    },
    isWorkingDay (userName, date) {
      return (['', 'x'].indexOf(this.getUserDayType(userName, date)) !== -1)
    },
    isWeekendOrHoliday (userName, date) {
      return ['w', 'hs'].indexOf(this.getUserDayType(userName, date)) !== -1
    },
    isProjectWeekend (dateFormatted) {
      const day = dateFormatted.slice(-3)
      return day === 'Sat' || day === 'Sun'
    },
    isNotWorkingDay (report, date) {
      return this.getReportDateAttribute(report, date, 'spent_time') === 0
    },
    isVacationDay (userName, date) {
      return (['time_off', 'v'].indexOf(this.getUserDayType(userName, date)) !== -1)
    },
    isDisplayHalfDay (report, totalItemDate) {
      const dateAttr = this.getReportDateAttribute(report, totalItemDate, 'spent_time')

      if (this.showZeroValues) {
        return (report.dates[totalItemDate].time_off_spent_time && dateAttr)
      } else {
        return false
      }
    },
    isSickDay (userName, date) {
      return (['s'].indexOf(this.getUserDayType(userName, date)) !== -1)
    },
    getDayTitle (report, date) {
      return report.user.name + ' ' + date
    },
    onReset () {
      /* Reset our form values */
      this.form.date_from = ''
      this.form.date_to = ''
      this.form.projects = []
      this.form.users = []
      this.form.unitManagers = []
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    async openTimeOffReportModal (user) {
      const route = this.$router.resolve({
        name: 'time-off-report-id',
        params: {
          id: user.id
        }
      })
      window.history.pushState({}, '', route.href)
      this.timeOffReportUserId = user.id
      this.isCommonTimeOffReport = false
      this.showTimeOffReport = true
      this.scrollToTheTop()
    },
    async openCommonTimeOffReportModal () {
      this.timeOffReportUserId = null
      this.isCommonTimeOffReport = true
      this.showTimeOffReport = true
      this.scrollToTheTop()
    },
    closeTimeOffReport () {
      const route = this.$router.resolve({
        name: this.$route.name,
        params: this.$route.params
      })
      window.history.pushState({}, '', route.href)
      this.showTimeOffReport = false
      this.restoreScrollPosition()
    },
    timeOffApproved () {
      this.timeOffForApproveId = null
      setTimeout(() => {
        this.reloadReport()
      }, 1000)
    },
    getHeaderDateFormatted (date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM')
    },
    getHeaderWeekdayFormatted (date) {
      return moment(date, 'YYYY-MM-DD').format('ddd')
    },
    formatLogTime (time) {
      if (time === '') {
        return time
      }

      return Math.round(parseFloat(time) * 100) / 100
    }
  }
}
</script>

<style scoped lang="scss">
$cell-border-radius: 2px;

.log-time-report {
  ::v-deep .log-time-report-filter-switch {
    margin-top: 4px;
    margin-bottom: 10px;
  }
}

.table-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding-top: 0;
}

/* Loading overlay for log time report tabs and controls */
::v-deep .fullscreen-tabs.loading-data {
  position: relative;
}

::v-deep .fullscreen-tabs.loading-data::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $tableModalBgOverlay;
  border-radius: 10px;
  z-index: 13;
  pointer-events: all;
}

::v-deep .fullscreen-tabs.loading-data::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 37px;
  height: 37px;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: log-time-spinner 0.75s linear infinite;
  color: $sinnerColor;
  z-index: 15;
}

@keyframes log-time-spinner {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.loader {
  position: relative;
  background-color: transparent;
}

.weekend {
  background-color: #e2e7ee;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $cell-border-radius;
}

.total {
  font-size: 11px;
  color: #7489a9;
  text-transform: uppercase;
  height: 60px;
}

.report-icon {
  color: $fontColorAccent;
}

.cursor-pointer {
  cursor: pointer;
}

.title-container__controls {
  align-items: center;

  // button {
  //   height: 30px;
  // }
}

.switch-group {
  margin-top: 5px;
  margin-right: 6px;
  white-space: nowrap;

  &:first-child {
    margin-right: 32px;
  }

  .switch {
    ::v-deep .custom-control-label {
      font-size: 0.8125rem;
    }
  }
}

.working-day-w .spent-time,
.working-day-h .spent-time {
  background-color: #e2e7ee;
  color: #7489a9;
}

/* .working-day-time_off .spent-time {
  background-color: #e3e2b0;
  color: #7489a9;
} */

.working-day-x .spent-time {
  background-color: #fff;
  color: #7489a9;
}

.working-day-part-time .spent-time {
  background-color: $txtError;
  color: #fff;
}

.column {
  flex-direction: column;
}

.spent-time {
  display: flex;
  color: $fontColor2;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: $cell-border-radius;

  .sick-day {
    width: 100%;
    min-height: 40px;
    background-color: $colorOrange;
    border-radius: $cell-border-radius;
  }

  .vacation-day {
    width: 100%;
    min-height: 40px;
    background-color: $buttonBgColor3;
    border-radius: $cell-border-radius;
  }

  .half-day {
    min-height: 20px;
  }
}

table#table-transition {
  transition: transform 1s;
}

.card {
  overflow-x: scroll;
}

/* Main table */
.table {
  width: initial;
  min-width: 100%;
  table-layout: auto;

  td,
  th {
    padding: 5px;
  }

  td:first-child,
  th:first-child {
    width: 27px;
    min-width: 27px;
    padding-left: 10px;
    padding-right: 2px;
  }

  td:not(:first-child),
  th:not(:first-child) {
    min-width: 65px;
  }
}

.table-fixed {
  display: block;
  height: 500px;
  overflow: auto;
}

.th-name {
  width: 180px;
}

.th-else {
  text-align: center;
}

.task-col {
  width: 220px;
}

.booking-user-name {
  font-size: 13px;
  color: $tableTextHeadColor2;
  margin-bottom: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.booking-user-position {
  font-size: 11px;
  color: $tableTextHeadColor;
  text-overflow: ellipsis;
  overflow: hidden;
}

.user-position {
  font-size: 11px;
  color: $tableTextHeadColor;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  white-space: nowrap;
  min-height: 16px;
}

.name-col {
  width: 150px;
}

.tasks-name-col {
  width: 130px;
}

.task-name-link {
  text-overflow: ellipsis;
  overflow: hidden;
  max-height: 40px;
  text-decoration: none;
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
